import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { SideAds } from "./components/SideAds.jsx";
import { RoomProvider } from "./contexts/RoomContext.jsx";
import { SoloAuthProvider } from "./contexts/SoloAuthContext.jsx";
import { SoundProvider } from "./contexts/SoundContext.jsx";
import { installSessionLifecycle } from "./services/sessionLifecycle.js";
import "./styles.css";

installSessionLifecycle();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <SoundProvider>
      <SoloAuthProvider>
        <RoomProvider>
          <App />
          <SideAds />
        </RoomProvider>
      </SoloAuthProvider>
    </SoundProvider>
  </StrictMode>,
);
